import ProjectApi from '../api/ProjectApi';

class ProjectRepository {
  private projectApi = new ProjectApi();

  public async getProjects(organizationId: string) {
    return this.projectApi.getProjects(organizationId);
  }

  public async getProject(organizationId: string, projectId: string) {
    return this.projectApi.getProject(organizationId, projectId);
  }

  public async createProject(organizationId: string, name: string) {
    return this.projectApi.createProject(organizationId, name);
  }

  public async editProject(
    organizationId: string,
    projectId: string,
    name: string,
  ) {
    return this.projectApi.editProject(organizationId, projectId, name);
  }

  public async deleteProject(organizationId: string, projectId: string) {
    return this.projectApi.deleteProject(organizationId, projectId);
  }

  public async assignCourses(
    organizationId: string,
    projectId: string | null,
    courseIds: string[],
  ) {
    return this.projectApi.assignCourses(organizationId, projectId, courseIds);
  }
}

export default ProjectRepository;
